import * as React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";

export default function PlainCard({ name, value, note }) {  
  return (
    <Card sx={{ minWidth: 200, maxWidth:270, height:100, margin:"5px" ,marginBottom:"5px" }}>
      <CardContent>
        <Typography variant="h5" component="div">
          {name}
        </Typography>
        <Typography variant="h4">{value}</Typography>
        {note && (
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: '8px' }}>
                        <Typography variant="caption" color="textSecondary">
                            {note}
                        </Typography>
                    </Box>
                )}
      </CardContent>
    </Card>
  );
}
